import { Outlet } from 'react-router-dom'
import {
    RedirectToSignIn,
    SignedIn,
    SignedOut,
    useAuth,
} from '@clerk/clerk-react'
import { useRequestInterceptor } from '../api/config'
import { MerchantDashboard } from './MerchantDashboard'

export const ProtectedLayout = ({ isDashboardLayout = true }) => {
    const { getToken } = useAuth()
    useRequestInterceptor({ getToken })

    return (
        <div>
            <SignedIn>
                {isDashboardLayout ? <MerchantDashboard /> : <Outlet />}
            </SignedIn>

            <SignedOut>
                <RedirectToSignIn />
            </SignedOut>
        </div>
    )
}
